'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'PStatusRestService',
    function ($modal, PStatusRestService) {

        return {
            edit: edit,
            create: create,
            api: PStatusRestService
        };

        function create() {
            return $modal.open({
                template: require('../view/pstatus-modal-create.html'),
                controller: 'PStatusModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    pstatus: function () {
                        return {};
                    }
                }
            });
        }

        function edit(item) {
            return $modal.open({
                template: require('../view/pstatus-modal-create.html'),
                controller: 'PStatusModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    pstatus: function () {
                        return item;
                    }
                }
            });
        }

    }];